/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Box, Container, List, ListItem, ListItemAvatar, ListItemSecondaryAction, Paper, Typography, Zoom } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import * as PropTypes from "prop-types";

import AppButton from "../../../../components/AppButton";
import AppAutoComplete from "../../../../components/AppAutoComplete";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { EVENTS } from "../../../../utils/events";
import { getCurrencyListFiat, getFiatCountriesApi, getFiatCurrenciesApi, getFiatOptionsApi, getFiatStatus, logEvent, userCreate } from "../../../../store/api";
import { FIAT_CONFIG_STATUS, paymentOptions } from "../../../../utils/constants";
import { getSerivceProvider } from "../../../../store/actions";
import AppDialogHalfScreen from "../../../../components/AppDialogHalfScreen";
import { formatFee, getDisplayFee, isKycVerified, showFiatPopup } from "../../../../utils";
import { Home, Warning } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ach from '../../../../assets/logo/ach.svg';
import wire from '../../../../assets/logo/wire.svg';
import sepa from '../../../../assets/logo/sepa.svg';
import spei from '../../../../assets/logo/spei.svg';
import coelsa from '../../../../assets/logo/coelsa.svg';
import cce from '../../../../assets/logo/cce.svg';
import spav from '../../../../assets/logo/spav.svg';
import pse from '../../../../assets/logo/pse.svg';
import eft from '../../../../assets/logo/eft.svg';
import mobilemoney from '../../../../assets/logo/mobilemoney.svg';
import { S3_GYL_ICONS } from "../../../../utils/config";
import AppLoader from "../../../../components/AppLoader";
import { getUserSelector } from "../../../../utils/selectorHelpers";

const icons = {
  ach,
  wire,
  sepa,
  spei,
  coelsa,
  cce,
  spav,
  pse,
  eft,
  mobilemoney
}
export default function OptionSelect({
  setActive,
  setOptionSelectMode = () => {},
  active,
  country,
  setCountry,
  currency,
  setCurrency,
  fiatOption,
  setFiatOption,
  amount,
  destinationRecord,
  setDestinationRecord
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const account = useSelector(({ Auth }) => Auth?.account)
  const [continueLoading, setContinueLoading] = useState(false);
  const user = useSelector(getUserSelector);
  const [showOptions, setShowOptions] = useState(false);
  const [currencyOption, showCurrencyOption] = useState(false);
  const [optionLoader, setOptionLoader] = useState(false);
  const [fiatOptions, setFiatOptions] = useState([]);
  const [loadFiatOptions, setLoadFiatOptions] = useState(true);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const [paymentPayer, setPaymentPayer] = useState([]);
  const navigate = useNavigate();
  const [fiatStatus, setFiatStatus] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const fetchFiatStatus = useCallback(async () => {
    try {
      if (isKycVerified(user)) {
        const response = await getFiatStatus();
        setFiatStatus(response.result);
        const flag = showFiatPopup(response.result);
        setShowDialog(flag);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchFiatStatus();
    if (isKycVerified(user)) {
      userCreate();
    }
  }, []);
  useEffect(() => {
    if (showOptions || currencyOption) {
      setOptionSelectMode("transfer-method");
      return;
    }
    setOptionSelectMode("country-currency");
  }, [showOptions, currencyOption, setOptionSelectMode]);
  useEffect(() => {
    return () => {
      setOptionSelectMode("country-currency");
    };
  }, [setOptionSelectMode]);
  const getFiatOptions = async () => {
    if (country && currency) {
      const resp = await getFiatOptionsApi(country.iso2, currency.id, amount);
      setFiatOptions(resp?.result?.methodsList || []); // default to array if nothing is loaded
      setLoadFiatOptions(false);
    }
  }
  useEffect(() => {
    setLoadFiatOptions(true)
    getFiatOptions();
  }, [country, currency])
  const handleChangeCountry = (value) => {
    setCurrency(null);
    setCountry(value);
  }
  const getCurrencies = async () => {
    const countryValue = fiatService?.serviceName === paymentOptions['type-3'] ? country?.iso3 : country?.iso2;
    const resp = await getFiatCurrenciesApi({ country: countryValue });
    return resp.result;
  };
  const getCountry = async () => {
    setCurrency(null);
    const resp = await getFiatCountriesApi();
    return resp.result.countryList;
  };

  const handleContinue = () => {
    setContinueLoading(true);
    if (fiatService?.serviceName === paymentOptions.masspay && fiatOptions?.length <= 1) {
      handleOptionSelection(fiatOptions[0]);
    } else if (fiatOptions.length > 0) {
      setShowOptions(true)
    } else {
      setActive(active + 1)
    }
    dispatch(getSerivceProvider(country.iso2, currency.id, () => {
      setContinueLoading(false);
    }));
    logEvent({
      current: EVENTS.BANK_TRANSFER.COUNTRY_CURRENCY_CONTINUE,
      activity: EVENTS.BANK_TRANSFER.COUNTRY_CURRENCY_CONTINUE,
      meta: {
        country,
        currency,
        fiatService
      }
    });
  }

  const handleOptionSelection = async (option) => {
    setFiatOption(option);
    if (optionLoader) {
      return;
    }
    if (fiatService?.serviceName === paymentOptions.masspay) {
      setOptionLoader(true)
      const response = await getCurrencyListFiat(amount, country.iso2, option.caption);
      if (response.result?.payers) {
        setPaymentPayer(response.result?.payers);
        setShowOptions(false);
        showCurrencyOption(true);
        setOptionLoader(false)
      } else {
        setDestinationRecord(response?.result);
        setOptionLoader(false)
        setActive(active + 1)
      }

    } else {
      setActive(active + 1)
    }
  }
  const handlePayerOptionSelection = (value) => {
    setDestinationRecord(value);
    showCurrencyOption(false);
    setActive(active + 1)
  }

  const getLogo = (icon) => {
    const Component = icons[icon];
    return <Component />;
  }
  const options = () => {
    return <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 1,
      }}
    >
      <List>
        {fiatOptions.map((option, index) => <ListItem
          key={index}
          aria-label="tracker"
          aria-describedby="transfer_options_banktransfer"
          selected={option?.caption === fiatOption?.caption}
          onClick={(ev) => handleOptionSelection(option)}
          disabled={!fiatService?.enableFiat}
        >
          <ListItemAvatar>
            <Avatar
              aria-label="tracker"
              aria-describedby="transfer_method_crypto"
            >
              {getLogo(option.icon)}
            </Avatar>
          </ListItemAvatar>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography fontWeight={600} textTransform={'uppercase'}>{option.text}</Typography>
            {formatFee(option, account) && <Typography fontSize={12} textTransform={'capitalize'}>{formatFee(option, account) ? 'Fee:' : ''} <s>{formatFee(option, account) ? getDisplayFee(option, account) : ''}</s> &nbsp;&nbsp;{formatFee(option, account)}</Typography>}
            {option?.subtitle && <Typography fontSize={12}>{option?.subtitle}</Typography>}
          </Box>
          <ListItemSecondaryAction>
            {optionLoader && <AppLoader />}
          </ListItemSecondaryAction>
        </ListItem>)}

      </List>
    </Paper>
  }
  const getPayerIcons = (icon) => {
    try {
      const Logo = `${S3_GYL_ICONS}/fiat/${icon.toLowerCase()}.svg`;
      return Logo;
    } catch (err) {
      return ""
    }
  }
  const currencyOptions = () => {
    return <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 1,
      }}
    >
      <List>
        {paymentPayer.map((option) => <ListItem
          aria-label="tracker"
          aria-describedby="transfer_options_banktransfer"
          selected={option?.destinationRecordId === destinationRecord?.destinationRecordId}
          onClick={(ev) => handlePayerOptionSelection(option)}
          disabled={!fiatService?.enableFiat}
        >
          <ListItemAvatar>
            <Avatar
              aria-label="tracker"
              aria-describedby="transfer_method_crypto"
            >
              <img src={getPayerIcons(option.icon)} alt="icon" />
            </Avatar>
          </ListItemAvatar>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography fontWeight={600}>{option.name}</Typography>
            {formatFee(option, account) && <Typography fontSize={12} textTransform={'capitalize'}>Fee <s>{getDisplayFee(option, account)}</s> &nbsp;&nbsp;{formatFee(option, account)}</Typography>}
            {option?.subtitle && <Typography fontSize={12}>{option?.subtitle}</Typography>}
          </Box>
        </ListItem>)}

      </List>
    </Paper>
  }

  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 1,
      }}
    >
      <AppDialogHalfScreen show={showDialog} setShow={setShowDialog}>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <Warning sx={{ color: '#F8F8F8', width: 50, height: 50 }} />
          {/* <Typography sx={getFiatErrorStyle(fiatStatus)} textTransform={'capitalize'} fontSize={18}>{getFiatErrorTitle(fiatStatus)}!</Typography> */}
        </Box>

        <Container sx={{ minWidth: 200, marginTop: 2 }} disableGutters>
          <Typography color={'#F8F8F8'} fontSize={14} textAlign={'center'}>{fiatStatus?.message}</Typography>
          {fiatStatus?.errorType === FIAT_CONFIG_STATUS.error && <AppButton
            startIcon={<Home />}
            title={t("BackDashboard")}
            onClick={() => navigate("/home")}
            sx={{ marginTop: 2 }}
          />}
        </Container>
      </AppDialogHalfScreen>
      {showOptions && options()}
      {currencyOption && currencyOptions()}
      {!showOptions && !currencyOption && <Box>
        <Zoom in={true} style={{ transitionDelay: "100ms" }}>
          <Typography variant="subtitle2" textAlign={"left"}>{t("pockyt.step1.desc")}</Typography>
        </Zoom>
        <Zoom in={true} style={{ transitionDelay: "100ms" }}>
          <Box marginTop={2}>
            <AppAutoComplete
              label={t('Select country')}
              getData={getCountry}
              onSelect={handleChangeCountry}
              defaultValue={country}
              optionKey="name"
            />
          </Box>
        </Zoom>
        <Zoom in={true} style={{ transitionDelay: '100ms' }}>
          <Box marginTop={0.5}>
            <Typography fontSize={12}>
              {t('testingBank')}
            </Typography>
          </Box>
        </Zoom>
        {!!country && (
          <Zoom in={true} style={{ transitionDelay: "100ms" }}>
            <Box marginTop={2}>
              <AppAutoComplete
                label={t('selectCurrency')}
                getData={getCurrencies}
                onSelect={setCurrency}
                defaultValue={currency}
              />
            </Box>
          </Zoom>
        )}
        {!!(currency && country) && (
          <Zoom in={true} style={{ transitionDelay: "100ms" }}>
            <Box marginTop={2}>
              {currency.showEurWarning && (
                <Typography fontSize={12}>
                  {t('bank.euRegion.warning')}
                </Typography>
              )}
              <AppButton
                loading={continueLoading || loadFiatOptions}
                disabled={loadFiatOptions}
                title={"Continue"}
                onClick={handleContinue}
                sx={{ marginTop: 2 }}
              />
            </Box>
          </Zoom>
        )} </Box>}
    </Paper>
  );
}

OptionSelect.propTypes = {
  amount: PropTypes.any,
  setActive: PropTypes.func,
  setOptionSelectMode: PropTypes.func,
  active: PropTypes.number,
  setShowKytBlocked: PropTypes.func,
  setShowKyt: PropTypes.func,
  country: PropTypes.any,
  setCountry: PropTypes.func,
};
